import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import smtpApiController from "../../services/smtp.service";
import HandleError from "../HandleError";
import HandleResponse from "../HandleResponse";
import { contentErrorMessage } from "./contentError";

const smtpErrorMessage = (action, fallback) => contentErrorMessage(action, fallback);

export const SmtpUpdateApi = createAsyncThunk("smtp/update", async (formValues, thunkAPI) => {
  try {
    const resposedata = await smtpApiController
      .update(formValues, thunkAPI)
      .then((response) => HandleResponse(thunkAPI, response, "update"))
      .catch((error) => HandleError(thunkAPI, error, "update"));
    return resposedata;
  } catch (error) {
    const message = (error.response && error.response.data && error.response.data.message) || error.message || error.toString();
    return thunkAPI.rejectWithValue(message);
  }
});

export const SmtpDetailApi = createAsyncThunk("smtp/detail", async (formValues, thunkAPI) => {
  try {
    const resposedata = await smtpApiController
      .view(formValues, thunkAPI)
      .then((response) => HandleResponse(thunkAPI, response, "detail"))
      .catch((error) => HandleError(thunkAPI, error, "detail"));
    return resposedata;
  } catch (error) {
    const message = (error.response && error.response.data && error.response.data.message) || error.message || error.toString();
    return thunkAPI.rejectWithValue(message);
  }
});

export const SmtpTestMailApi = createAsyncThunk("smtp/testmail", async (formValues, thunkAPI) => {
  try {
    const resposedata = await smtpApiController.testmail(formValues, thunkAPI)
      .then((response) => HandleResponse(thunkAPI, response, "testmail"))
      .catch((error) => HandleError(thunkAPI, error, "testmail"));
    return resposedata;
  } catch (error) {
    const message = (error.response && error.response.data && error.response.data.message) || error.message || error.toString();
    return thunkAPI.rejectWithValue(message);
  }
});

const initialState = {
  isDetailData: "",
  isDetailDataError: "",
  isSmtp: "",
  isSmtpError: "",
  isOpenedSmtpForm: "",
  isOpenedSmtpTestMailModal: "",
  isTestMail: "",
  isTestMailError: "",
  isApiStatus: {
    SmtpUpdateApi: "",
    SmtpDetailApi: "",
    SmtpTestMailApi: "",
  },
};


const smtpSlice = createSlice({
  name: "smtp",
  initialState,
  reducers: {
    reset: () => initialState,
    OpenSmtpForm: (state, action) => {
      state.isOpenedSmtpForm = action.payload;
    },
    SmtpTestMailModal: (state, action) => {
      state.isOpenedSmtpTestMailModal = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(SmtpUpdateApi.pending, (state) => {
        state.isSmtpError = "";
        state.isApiStatus = { ...state.isApiStatus, SmtpUpdateApi: "loading" };
      })
      .addCase(SmtpUpdateApi.fulfilled, (state, action) => {
        state.isApiStatus = { ...state.isApiStatus, SmtpUpdateApi: "succeeded" };
        state.isSmtp = action.payload;
        state.isSmtpError = "";
      })
      .addCase(SmtpUpdateApi.rejected, (state, action) => {
        state.isApiStatus = { ...state.isApiStatus, SmtpUpdateApi: "failed" };
        state.isSmtpError = smtpErrorMessage(action, "Unable to save SMTP settings.");
      })
      .addCase(SmtpDetailApi.pending, (state) => {
        state.isDetailDataError = "";
        state.isApiStatus = { ...state.isApiStatus, SmtpDetailApi: "loading" };
      })
      .addCase(SmtpDetailApi.fulfilled, (state, action) => {
        state.isApiStatus = { ...state.isApiStatus, SmtpDetailApi: "succeeded" };
        state.isDetailData = action.payload;
        state.isDetailDataError = "";
      })
      .addCase(SmtpDetailApi.rejected, (state, action) => {
        state.isApiStatus = { ...state.isApiStatus, SmtpDetailApi: "failed" };
        state.isDetailDataError = smtpErrorMessage(action, "Unable to load SMTP settings.");
      })
      .addCase(SmtpTestMailApi.pending, (state) => {
        state.isTestMailError = "";
        state.isApiStatus = { ...state.isApiStatus, SmtpTestMailApi: "loading" };
      })
      .addCase(SmtpTestMailApi.fulfilled, (state, action) => {
        state.isApiStatus = { ...state.isApiStatus, SmtpTestMailApi: "succeeded" };
        state.isTestMail = action.payload;
        state.isTestMailError = "";
      })
      .addCase(SmtpTestMailApi.rejected, (state, action) => {
        state.isApiStatus = { ...state.isApiStatus, SmtpTestMailApi: "failed" };
        state.isTestMailError = smtpErrorMessage(action, "Unable to send test email.");
      });
  },
});
// Action creators are generated for each case reducer function
export const { reset, OpenSmtpForm, SmtpTestMailModal } = smtpSlice.actions;
export default smtpSlice.reducer;
